module.exports = __webpack_public_path__ + "static/media/nude.c63ea157.ogg";